import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Modal from '../../common/Modal';
import Button from '../../common/Button';
import WrapperSecondary from '../../common/WrapperSecondary';
import ProjectCreate from '../../projects/create/';
import JoinProjectsToUser from '../../user/join-projects/';
import { requestDataIfNeeded as requestUserDataIfNeeded } from '../../user/duck';

class Screen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  handleProjectAddSuccess = () => {
    this.props.requestUserDataIfNeeded();
    this.closeModal();
  };

  render() {
    const { t } = this.props;

    return (
      <WrapperSecondary
        title={t('onboarding.addSideProjects.title')}
        subtitle={t('onboarding.addSideProjects.subtitle')}
      >
        <h3 className="c-heading--alpha u-margin-top-huge">
          {t('onboarding.addSideProjects.joinProject')}
        </h3>
        <JoinProjectsToUser projectsType="SIDE" />

        <h3 className="c-heading--alpha u-margin-top-large">
          {t('onboarding.addSideProjects.addProject')}
        </h3>
        <Button styleType="outline" onClick={this.openModal}>
          {t('onboarding.addSideProjects.addProjectBtn')}
        </Button>

        <div className="u-text-center u-margin-top-huge">
          <Button
            styleType="secondary"
            onClick={() => this.props.history.push('/onboarding/add-goals')}
          >
            {t('general.continue')}
          </Button>
        </div>

        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          title={t('onboarding.addSideProjects.modalTitle')}
        >
          <ProjectCreate type="SIDE" onSuccess={this.handleProjectAddSuccess} />
        </Modal>
      </WrapperSecondary>
    );
  }
}

const mapDispatchToProps = { requestUserDataIfNeeded };

export default connect(
  null,
  mapDispatchToProps
)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/onboarding/add-side-projects/Screen.js